const DEFAULT_APP_NAME = 'welcome';
const OFFER_APP_NAME = 'offer';
const COUPON_APP_NAME = 'campaign';

const HOME_PATH = '/';
const SUCCESS_PATH = '/success';
const OFFER_SUCCESS_PATH = '/complete';
const COMPONENTS_PATH = '/components';
const BILLING_PATH = '/billing-plans';
const FOUR_O_FOUR = '/404';
const LOGIN_PATH = '/login';
const REGISTER_PATH = '/register';
const ALREADY_PREMIUM_PATH = '/already-premium';

const INTERNAL_FOUR_O_FOUR = '/error';
const UNAVAILABLE_PATH = '/unavailable';
const OFFER_INELIGIBLE_PATH = '/offer-ineligible';
const INVALID_COUPON_PATH = '/offer-invalidcoupon';
const FREE_TRIAL_PATH = '/freetrial/freetrial';
const CHECKOUT_V2_PATH = '/payments/checkout';
const REDIRECT_SECURE_PATH = '/_redirect_secure';
const SUBSCRIPTIONS_PURCHASE = '/subscriptions/purchase';
const SERIES_PATH = '/series';
const XBOX_LANDING_PATH = '/gamepassultimate';
const MIGRATION_LANDING_PATH = '/nextlevel';
const MIGRATION_SUCCESS_PATH = '/success-nextlevel';
const REGISTRATION_PROMO_PATH = '/registration-premium-prompt';
const PRICING_PROMO_LANDING_PATH = '/pricing-promo';
const PRICING_PROMO_SUCCESS_PATH = '/pricing-promo-success';

// Query Params
const RETURN_URL_QUERY = 'return_url';
const FAILURE_URL_QUERY = 'failure_url';
const CLIENT_TYPE_QUERY = 'client_type';
const SELECTED_SKU = 'selected_sku';
const SKU_QUERY = 'sku';
const COUPON_QUERY = 'coupon_code';
const HOME_PAGE_QUERY = 'homepage';
const NEXT = 'next';
const FROM_FREE_TRIAL_PROMPT = 'fromfreetrialprompt';
const FREE_TRIAL_PROMPT = 'freetrialprompt';
const CAMPAIGN = 'campaign';

export {
  DEFAULT_APP_NAME,
  OFFER_APP_NAME,
  COUPON_APP_NAME,
  HOME_PATH,
  SUCCESS_PATH,
  OFFER_SUCCESS_PATH,
  COMPONENTS_PATH,
  BILLING_PATH,
  FOUR_O_FOUR,
  LOGIN_PATH,
  REGISTER_PATH,
  ALREADY_PREMIUM_PATH,
  INTERNAL_FOUR_O_FOUR,
  FREE_TRIAL_PATH,
  CHECKOUT_V2_PATH,
  REDIRECT_SECURE_PATH,
  SUBSCRIPTIONS_PURCHASE,
  UNAVAILABLE_PATH,
  SERIES_PATH,
  OFFER_INELIGIBLE_PATH,
  INVALID_COUPON_PATH,
  XBOX_LANDING_PATH,
  MIGRATION_LANDING_PATH,
  MIGRATION_SUCCESS_PATH,
  REGISTRATION_PROMO_PATH,
  PRICING_PROMO_LANDING_PATH,
  PRICING_PROMO_SUCCESS_PATH,
  // Query Params
  RETURN_URL_QUERY,
  FAILURE_URL_QUERY,
  CLIENT_TYPE_QUERY,
  SELECTED_SKU,
  SKU_QUERY,
  COUPON_QUERY,
  HOME_PAGE_QUERY,
  NEXT,
  FROM_FREE_TRIAL_PROMPT,
  FREE_TRIAL_PROMPT,
  CAMPAIGN,
};
